// extracted by mini-css-extract-plugin
export var numpadContainer = "_o0-1";
export var phoneButton = "_o0-0";